"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateToYMD = formatDateToYMD;
exports.fnGetDateRange = fnGetDateRange;
function formatDateToYMD(date) {
    if (!date)
        return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${y}-${m}-${d} ${h}:${min}`;
}
function fnGetDateRange(startAt, endAt) {
    const start = formatDateToYMD(startAt);
    const end = formatDateToYMD(endAt);
    if (!start && !end)
        return '';
    return `${start} ~ ${end}`;
}
